import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { rem } from "polished";
import React, { useState } from "react";

import { Box, Chevron, Label } from "../../base";

const SectionHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  opacity: 0.4;

  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const Section = styled(Box)`
  padding: ${rem(32)} ${rem(32)} ${rem(36)};
`;

const CollapsableSection = ({ title, figure = null, children, ...props }) => {
  // React.Children.count(children) > 0
  const [open, setOpen] = useState(true);

  return (
    <Section {...props}>
      <SectionHeader onClick={() => setOpen(!open)}>
        <Label
          css={css`
            flex: 1;
            text-transform: uppercase;
            font-size: ${rem(16)};
            line-height: ${rem(24)};
            letter-spacing: ${rem(1)};
          `}
        >
          {title}
        </Label>
        {!open && figure}
        <Chevron
          css={css`
            transform: rotate(${open ? 90 : 0}deg);
          `}
          stroke="#000"
        />
      </SectionHeader>
      {open ? (
        <div
          css={css`
            margin-top: ${rem(28)};
            /* padding: 0;

            max-height: ${rem(180)};
            overflow: scroll; */
          `}
        >
          {children}
        </div>
      ) : null}
    </Section>
  );
};

export default CollapsableSection;
